import appnexus from './appnexus';
import noAppnexus from './appnexus/no';
import seAppnexus from './appnexus/se';

const commonConfig = { service: 'appnexus' };

export const dk = { ...commonConfig, appnexus };
export const es = { ...commonConfig, appnexus };
export const fi = { ...commonConfig, appnexus };
export const fr = { ...commonConfig, appnexus };
export const gb = { ...commonConfig, appnexus };
export const ie = { ...commonConfig, appnexus };
export const it = { ...commonConfig, appnexus };
export const no = { ...commonConfig, appnexus: noAppnexus };
export const nz = { ...commonConfig, appnexus };
export const pl = { ...commonConfig, appnexus };
export const se = { ...commonConfig, appnexus: seAppnexus };

export default {
  dk,
  es,
  fi,
  fr,
  gb,
  ie,
  it,
  no,
  nz,
  pl,
  se,
};
